import { subStringInfo, subStringInfo2 } from '../utils';
import Logger from '../Logger';

const logger = new Logger('subtitles');

const subtitles = (state = [], action) =>
{
	switch (action.type)
	{
		case 'ADD_SUBTITLE':
		{
			const _subtitles = [...state];
			/*
			{
				displayName,
				text,
				isFinal
			}
			*/
			const { subtitle } = action.payload;
			const _isFinal = subtitle.isFinal;   // 代表是否一句结束
			if (
				// (!_isFinal && Array.isArray(_subtitles)) ||  // 语句没有结束时,需要清掉之前内容
				(_subtitles.at(-1) && _subtitles.at(-1).isFinal === false)   // 如果语句没有结束,需要清掉之前内容
			) {
				/*
				{
					displayName, 昵称
					texts,       文本数组
					isFinal      是否结束
					length       文本长度(截取后字符串的长度)
					lines        行数
					origTexts    原文本数组
					origLength
					origLines
				}
				*/
				const _lastSubtitle = _subtitles.pop();  // 删除最后一个元素

				logger.debug(`state:subtitles -> 上一句内容为:${JSON.stringify(_lastSubtitle)}`);
			}

			const _displayNameInfo = subStringInfo(subtitle.displayName, 18, true);

			subtitle.displayName = _displayNameInfo.text;
			// 存放文本的长度( 总长度- 昵称占用长度)
			const _textRowLength = 90 - (_displayNameInfo.length % 2 === 0 ? _displayNameInfo.length : _displayNameInfo.length + 1); // 90 为行总长度
			/*
			{
				texts
				length
				lines
				origTexts
				origLength
				origLines
			}
			*/
			const _textInfo = subStringInfo2(subtitle.text, 2, _textRowLength);

			const _subtitle = {
				...subtitle,
				..._textInfo
			};

			logger.debug(`state:subtitles -> subtitle: ${JSON.stringify(_subtitle)}  subtitles: ${JSON.stringify(_subtitles)}`);

			if (_subtitles.length === 0) {

				const _mergeSubtitles = [ ..._subtitles, _subtitle ];
				logger.debug(`state:subtitles -> 0 ${JSON.stringify(_mergeSubtitles)}`);
				return _mergeSubtitles;
			} else if (_subtitles.length === 1) {

				const _currSubtitle = _subtitles[0];
				if (_currSubtitle.lines === 1 && _subtitle.lines === 1) {

					const _mergeSubtitles = [ ..._subtitles, _subtitle ];
					logger.debug(`state:subtitles -> 1:1:1 ${JSON.stringify(_mergeSubtitles)}`);
					return _mergeSubtitles;
				} else if (_currSubtitle.lines === 1 && _subtitle.lines === 2) {

					const _mergeSubtitles = [ _subtitle ];
					logger.debug(`state:subtitles -> 1:1:2 ${JSON.stringify(_mergeSubtitles)}`);
					return _mergeSubtitles;
				} else if (_currSubtitle.lines === 2 && _subtitle.lines === 1) {
					/**
					将 _currSubtitle 中的 texts 删除掉一行,
					texts
					length
					lines
					*/
					const _shiftText = _currSubtitle.texts.shift();
					_currSubtitle.lines = _currSubtitle.lines -1;
					_currSubtitle.length = _currSubtitle.length - _shiftText.replace(/[^\x00-\xff]/g, '**').length;

					const _mergeSubtitles = [ ..._subtitles, _subtitle ];
					logger.debug(`state:subtitles -> 1:2:1 ${JSON.stringify(_mergeSubtitles)}`);
					return _mergeSubtitles;

				} else if (_currSubtitle.lines === 2 && _subtitle.lines === 2) {

					const _mergeSubtitles = [ _subtitle ];
					logger.debug(`state:subtitles -> 1:2:2 ${JSON.stringify(_mergeSubtitles)}`);
					return _mergeSubtitles;
				}
			} else if (_subtitles.length === 2) {

				// const _currSubtitle = _subtitles[0];  // 第一行内容
				/*
				if (_currSubtitle.displayName === _subtitles[1].displayName) {

					return [_subtitle];

				} else
				*/
				if (_subtitle.lines === 1) {

					_subtitles.shift();  // 删除第一个元素
					_subtitles.push(_subtitle);

					const _mergeSubtitles = [..._subtitles];
					logger.debug(`state:subtitles -> 2:1:1 ${JSON.stringify(_mergeSubtitles)}`);
					return _mergeSubtitles;
				} else if (_subtitle.lines === 2) {

					const _mergeSubtitles = [_subtitle];
					logger.debug(`state:subtitles -> 2:1:2 ${JSON.stringify(_mergeSubtitles)}`);
					return _mergeSubtitles;
				}
			}
		}

		case 'REMOVE_SUBTITLE':
		{
			const { subtitleId } = action.payload;

			return state.filter((subtitle) => subtitle.id !== subtitleId);
		}

		case 'REMOVE_ALL_SUBTITLES':
		{
			logger.debug(`state:subtitles -> REMOVE_ALL_SUBTITLES`);
			return [];
		}

		default:
			return state;
	}
};

export default subtitles;
